var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "197.35956mm",
    height: "139.2428mm",
    viewBox: "0 0 197.35956 139.2428",
    id: "svg5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 50.261978,
    height: 62.738483,
    id: "rect33366"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 50.261978,
    height: 62.738483,
    id: "rect33484"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 59.454369,
    height: 66.274017,
    id: "rect33490"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 50.261978,
    height: 62.738483,
    id: "rect33496"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 50.261978,
    height: 62.738483,
    id: "rect33502"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 50.261978,
    height: 62.738483,
    id: "rect33518"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 50.261978,
    height: 62.738483,
    id: "rect33524"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer8",
    transform: "translate(-399.16914,-16.892108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer9",
    transform: "translate(425.87012,19.725031)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "M 0.85606228,0 V 63.283295",
    id: "path30543"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "M 84.743873,0 V 66.463803",
    id: "path33067"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "M 56.781269,0 V 58.606079",
    id: "path33069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "M 28.818666,0 V 67.025069",
    id: "path33071"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "M 168.01276,16.113288 H -24.055151",
    id: "path33075"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,-34.611403,-75.833489)",
    id: "text33364",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      whiteSpace: "pre",
      shapeInside: "url(#rect33366)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#2f3333",
      strokeWidth: 6.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan50291"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan50289"
  }, "M"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,-5.7022316,-75.542034)",
    id: "text33482",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      whiteSpace: "pre",
      shapeInside: "url(#rect33484)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#2f3333",
      strokeWidth: 6.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan50295"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan50293"
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,19.969686,-75.444882)",
    id: "text33488",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      whiteSpace: "pre",
      shapeInside: "url(#rect33490)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#2f3333",
      strokeWidth: 6.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan50299"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan50297"
  }, "W"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,50.602132,-75.736337)",
    id: "text33494",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      whiteSpace: "pre",
      shapeInside: "url(#rect33496)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#2f3333",
      strokeWidth: 6.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan50303"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan50301"
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,77.737366,-75.639185)",
    id: "text33500",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      whiteSpace: "pre",
      shapeInside: "url(#rect33502)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#2f3333",
      strokeWidth: 6.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan50307"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan50305"
  }, "F"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "M 112.70648,-0.18708867 V 66.276714",
    id: "path33504"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "M 140.66908,0.93544334 V 59.541523",
    id: "path33506"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,105.84946,-75.841757)",
    id: "text33516",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      whiteSpace: "pre",
      shapeInside: "url(#rect33518)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#2f3333",
      strokeWidth: 6.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan50311"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan50309"
  }, "S"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,134.28021,-75.744605)",
    id: "text33522",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      whiteSpace: "pre",
      shapeInside: "url(#rect33524)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#2f3333",
      strokeWidth: 6.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan50315"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan50313"
  }, "S"))), /*#__PURE__*/React.createElement("path", {
    id: "rect42926",
    style: {
      fill: "#d3d3d3",
      stroke: "#d3d3d3",
      strokeWidth: 6.61501,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 91.844024,62.28155 c 0,0 0.58948,-7 7,-7 6.410516,0 6.999996,7 6.999996,7 v 70.82083 H 91.844024 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43222",
    style: {
      fill: "#d3d3d3",
      stroke: "#d3d3d3",
      strokeWidth: 6.61501,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 148.59715,62.28155 c 0,0 0.58948,-7 7,-7 6.41051,0 6.99999,7 6.99999,7 v 70.82083 h -13.99999 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43226",
    style: {
      fill: "#d3d3d3",
      stroke: "#d3d3d3",
      strokeWidth: 6.61501,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m -19.942434,41.638852 c 0,0 0.58948,7 7,7 6.4105157,0 6.9999957,-7 6.9999957,-7 V 23.470102 H -19.942434 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43232",
    style: {
      fill: "#d3d3d3",
      stroke: "#d3d3d3",
      strokeWidth: 6.61501,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 119.8128,41.638852 c 0,0 0.58948,7 7,7 6.41052,0 7,-7 7,-7 v -18.16875 h -14 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeek);
export default __webpack_public_path__ + "static/media/Week.dcf4027ca5f2236239e63f8b1fe99f81.svg";
export { ForwardRef as ReactComponent };